'use client';

import { Tile, Badge } from 'mode-shared/components';
import { Button } from 'mode-shared/components';
import Link from 'next/link';
import { useStakedAPY } from 'mode-shared/hooks/airdrop/lock/useStakedAPY';
import Image from 'next/image';
import { formatCurrency } from 'mode-shared/utils/format';

export const CTASection = () => {
  const { data: stakedAPY } = useStakedAPY();

  return (
    <Tile className="relative w-full flex flex-row gap-x-4 p-0 border-yellow-500 overflow-hidden lg:pr-[300px] bg-grey-950">
      <Image
        fill
        src="/assets/images/stake-widget-bg.jpeg"
        alt="Stake Mode"
        className="h-full hidden lg:block object-contain object-right"
      />
      <div className="flex flex-col md:flex-row gap-y-4 gap-x-7 p-7 z-10">
        <div className="w-full flex flex-col gap-y-2 font-sans">
          <h3 className="flex lg:items-center gap-x-2 font-semibold">
            Stake Mode for veMODE and earn OP
            {stakedAPY && (
              <Badge className="shrink-0 text-success border border-success-500 bg-transparent">
                {formatCurrency(stakedAPY, 0)}% APY
              </Badge>
            )}
          </h3>
          <p className="text-sm text-gray-300">
            MODE stakers earn OP rewards which can be claimed every 2 weeks and can use their veMODE to vote for apps,
            agents and streamers to get OP emissions
          </p>
        </div>
        <div className="flex flex-col gap-y-4 shrink-0">
          <div className="flex gap-4 w-full items-center lg:justify-end">
            <p className="text-xs text-gray-300">Stake your MODE and get OP</p>
            <Link href="https://gov.mode.network/plugins/voting/#/" target="_blank">
              <Button className="gap-x-2 w-full lg:w-fit capitalize px-5" size="sm">
                Stake
              </Button>
            </Link>
          </div>
          <div className="flex gap-4 w-full items-center lg:justify-end">
            <p className="text-xs text-gray-300">Claim staking rewards</p>
            <Link
              href="https://app.sablier.com/airdrops/?t=search&c=10&m=0x1fd06c720c18935fd58327a8fef9859445e2d40d&o=true"
              target="_blank"
            >
              <Button className="gap-x-2 w-full lg:w-fit capitalize px-5" size="sm">
                Claim
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Tile>
  );
};
